import React from 'react';

import StatisticsItem from '../../../containers/common/statistics/statisticsItem';

export const StatisticsItemsWrapper = ({ statisticsData, t }) => {
  return (
    <div className='m-game-statistics'>
      <div className='m-game-st-wr'>
        <div className='m-game-st-content'>
          {Object.keys(statisticsData).map((item, index) => {
            return (
              <StatisticsItem
                key={item}
                number={index + 1}
                percentage={statisticsData[item]}
                name={t(item.toUpperCase())}
                color={item.toLowerCase()}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
